// extracted by mini-css-extract-plugin
module.exports = {"footerActions":"deleteTemplateModal_footerActions__3_AfR","cancelButton":"deleteTemplateModal_cancelButton__1esLi","deleteButton":"deleteTemplateModal_deleteButton__1PMkM"};